import { render, staticRenderFns } from "./TeethHistory.vue?vue&type=template&id=7830a9ba&"
import script from "./TeethHistory.vue?vue&type=script&lang=js&"
export * from "./TeethHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports